export const WELCH_WINDOW = 256;
export const WELCH_OVERLAP = 128;
export const WELCH_NFFT = 512;
export const DEFAULT_WELCH_SAMPLE_RATE_HZ = 1;
